module.exports = __webpack_public_path__ + "img/cryoscorch.e169f047.jpg";